<template>
    <div
        v-if="$page.props.permissions['demandtimers-show']"
        class="mx-2 relative items-center flex pr-2 pl-1 py-1 space-x-2 dark:bg-slate-700 w-min rounded-md shadow-md bg-stone-300 dark:text-slate-200 text-stone-800"
    >
        <button
            v-if="clock.play && $page.props.permissions['demandtimers-edit']"
            @click="setPause()"
            class="py-1 px-2 rounded bg-stone-500 text-stone-900 dark:bg-slate-400 dark:text-slate-700 hover:bg-stone-400 dark:hover:bg-slate-300 duration-150 ease-out"
        >
            <font-awesome-icon icon="pause" />
        </button>

        <Badge
            :valor="timer.demand_id ?? timer.fk_id ?? ''"
            tipo="neutro"
            icon="briefcase"
        >
        </Badge>

        <Stopwatch
            v-if="clock.ready"
            :play="clock.play"
            :seconds="seconds"
        ></Stopwatch>
    </div>
</template>

<script setup>
import Stopwatch from "@/Components/Custom/Clocks/Stopwatch.vue";
import { router } from "@inertiajs/vue3";
import { usePage } from "@inertiajs/vue3";
import axios from "axios";
import Swal from "sweetalert2";
import { ref, reactive, computed, onBeforeMount, nextTick } from "vue";
import { useStore } from "vuex";
import Badge from "../Custom/Show/Badge.vue";

const store = useStore();
const seconds = ref(0);
const emit = defineEmits(["play", "pause"]);

const clock = reactive({
    play: false,
    ready: false,
});

const props = defineProps({
    set: {
        type: Object,
        default: null,
    },
    user_id: {
        type: [String, Number],
        default: null,
    },
});

const authenticated_user = usePage().props?.auth.user.id;
const hasPermission = usePage().props?.permissions["demandtimers-show"];
const user_id = props.user_id ?? authenticated_user;

function setPlay() {
    router.post(
        route("demands.playTimer"),
        {
            tabela: timer.tabela,
            fk_id: timer.id,
            demand_id: timer.id,
            user_id: props.user_id ?? authenticated_user,
            progress_id: timer.progress_id,
        },
        {
            onSuccess: () => {
                clock.play = true;
            },
        }
    );
}

function setPause() {
    Swal.fire({
        title: "Motivo da parada",
        icon: "info",
        input: "textarea",
        inputLabel: "Insira a razão da pausa",
        inputPlaceholder: "Escreva o motivo aqui...",
        inputAttributes: {
            "aria-label": "Escreva o motivo aqui",
        },
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#28A745",
        cancelButtonColor: "#6C757D",
        confirmButtonText: "SIM",
        cancelButtonText: "CANCELAR",
    }).then(({ isConfirmed, value }) => {
        if (!isConfirmed) {
            return false;
        }

        router.post(
            route("demands.pauseTimer"),
            {
                reason: value,
                tabela: timer.tabela,
                fk_id: timer.fk_id,
                user_id: authenticated_user,
                progress_id: timer?.progress_id,
            },
            {
                onSuccess: () => {
                    clock.play = false;
                    timer.value = {};
                },
            }
        );
    });
}

const timer = computed({
    get() {
        return store.state.timer.timer;
    },
    set(val) {
        store.dispatch("setTimer", val);
    },
});

function makeRequest() {
    if (!hasPermission) {
        return;
    }
    axios
        .post(route("demands.findTimer"), {
            user_id: user_id,
        })
        .then((res) => {
            let diferencaTimer = res.data.timer?.tempo_percorrido ?? 0;
            seconds.value = diferencaTimer;
            if (res.data.timer) {
                clock.play = true;

                if (res.data.timer.user_id == authenticated_user) {
                    timer.value = res.data.timer;
                }
            }
        })
        .finally(() => {
            clock.ready = false;
            nextTick(() => {
                clock.ready = true;
            });
        });
}

onBeforeMount(() => {
    makeRequest();
});
</script>
